/*
  HU06 Preventa -- "Picking Individual Preventa Traspaso" (TASKID 244,
  flowBolCI01, caso combinado traspaso+preventa). Recorte de
  externalForm11.js (TASKID 243, flowBolCI09) SIN el paso de Facturación --
  ver xflow_backv2/docs/preventa-pickup-otras-tiendas-draft.md secciones 2.2
  y 6/7 para el porqué: en este camino la factura real ocurre después, en
  "Registrar Entrega Cliente" (flowBolCI08, conector 99) -- reusar
  externalForm11.js tal cual habría dejado el botón "Facturar" disponible
  sin ningún gate, con riesgo real de doble facturación.

  Alcance idéntico a externalForm11.js salvo por eso: scan/pick, ajustar
  cantidad (+/-), agregar/quitar producto -- todo limitado a items con
  es_preventa=true del pedido. Sin gate de rol.
*/
import React from "react";
import {
  MDBNotification,
  MDBInputGroup,
  toast,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdbreact";
import { XInput, XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG } from "../../Config/config-env.js";
import axios from "axios";
import {
  applyExternalDarkMode,
  getCasaIdeasStores,
  getStoreCodeByOfficeCode,
  instanteBolivia,
} from "../../Config/functions";
import BarcodeScanner from "../../Components/BarcodeScanner";
import LockOverlay from "../../Components/LockOverlay";

// Toasts sin repetir: el mismo mensaje no se vuelve a mostrar mientras haya uno
// igual en pantalla (plan de pruebas PREVENTA 2026-10-08: al hacer varios clicks
// en un item que todavia no llego se apilaban N avisos iguales).
const _toastVisto = {};
const toastOnce = (tipo, mensaje, opciones) => {
  const clave = tipo + "|" + mensaje;
  const ahora = Date.now();
  if (_toastVisto[clave] && ahora - _toastVisto[clave] < 4000) return;
  _toastVisto[clave] = ahora;
  return toast[tipo](mensaje, opciones);
};

class externalForm13 extends React.Component {
  state = {
    loadingData: true,
    isLoadedTable: false,
    isExecuting: false,
    locked: false,

    token: "",
    WO_Id: "",
    WO_TaskId: "",
    officecode: "",
    flowcode: "",
    flowid: "",
    username: "",

    order_id: "",
    customer_id: "",
    customerName: "",
    branch_name: "",
    tipo_envio: "",

    orders: [],
    preventaMap: {},
    read_sku: "",
    progress_i: 0,
    picking_products_i: "",

    // agregar producto
    modalAdd: false,
    SKUcode: "",
    searchResults: [],
    productoAAgregar: null,
    checkandoSku: false,
    skuEsPreventa: null,
    skuCheckMessage: "",
    skuCheckWarehouse: "",

    // eliminar (confirm)
    modalDelete: false,
    id_producto: -1,
  };

  componentDidMount = async () => {
    await this.LoadTable();
  };

  // HU06 Preventa -- marca visual por SKU (rojo = todavia no llego, verde =
  // ya confirmada/vuelta a stock normal). Mismo endpoint que usa el gate de
  // "Picking Preventa"/"Picking Global Preventa" (externalForm12.js). Todos
  // los items de este form ya son de preventa (LoadTable los filtra), asi
  // que no hace falta chequear si el sku esta en la respuesta.
  loadPreventaStatus = async (order_id) => {
    if (!order_id) return;
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .then((data) => {
        const preventaMap = {};
        (data.items || []).forEach((item) => {
          preventaMap[item.sku] = item.disponible;
        });
        this.setState({ preventaMap });
      })
      .catch(() => {
        // No bloquea la pantalla si falla -- es solo una marca informativa
      });
  };

  // ---------------------------------------------------------------------
  // Carga: mismo patron que externalForm11.js (get-task-details ->
  // flowvars -> getorderById), filtrado a es_preventa=true desde el vamos.
  // ---------------------------------------------------------------------
  LoadTable = async () => {
    let params = new URLSearchParams(this.props.location.search);
    applyExternalDarkMode(this.props.location.search);
    const token = params.get("token");
    const WO_Id = params.get("wfpflowid");
    const WO_TaskId = params.get("wfptaskid");
    const locked = params.get("locked") === "true";
    const officecode = params.get("officecode");

    this.setState({ loadingData: true, token, WO_Id, WO_TaskId, officecode, locked });

    let order_id = 0;
    let customer_id = 0;
    let nombre_cliente = "";
    let branch_name = "";
    let tipo_envio = "";
    let picking_products_i = "";
    let progress_i = 0;
    let username = "";
    let flowcode = "";
    let flowid = "";

    const taskDetails = await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      data: { wfptaskid: WO_TaskId },
      method: "post",
    }).then((r) => r.data);

    if (!taskDetails.status) {
      toastOnce("error", "No se pudo cargar la tarea", { closeButton: true });
      this.setState({ loadingData: false });
      return;
    }

    flowcode = taskDetails.task.FLOWCODE;
    flowid = taskDetails.task.FLOWID;
    username = taskDetails.token ? taskDetails.token.USERNAME : "";

    for (const v in taskDetails.flowvars) {
      const flowVar = taskDetails.flowvars[v];
      if (flowVar.VARNAME === "order_id") order_id = flowVar.VARVALUE;
      if (flowVar.VARNAME === "customer_id") customer_id = flowVar.VARVALUE;
      if (flowVar.VARNAME === "nombre_cliente") nombre_cliente = flowVar.VARVALUE;
      if (flowVar.VARNAME === "branch_name") branch_name = flowVar.VARVALUE;
      if (flowVar.VARNAME === "tipo_envio") tipo_envio = flowVar.VARVALUE;
      if (flowVar.VARNAME === "picking_products_i") picking_products_i = flowVar.VARVALUE;
      if (flowVar.VARNAME === "progress_i") progress_i = parseInt(flowVar.VARVALUE) || 0;
    }

    let apikey = API_CONFIG.casaideasIntToken;
    const orderResp = await axios({
      url: API_CONFIG.getorderByIdpath,
      method: "post",
      data: { apikey, order_id, customer_id, adminpath: "matrix" },
    }).then((r) => r.data);

    let orderInfo = (orderResp.response && orderResp.response[0] && orderResp.response[0].order_info) || {};
    let products = (orderResp.response && orderResp.response[0] && orderResp.response[0].products) || [];

    const arrayPicked = picking_products_i ? picking_products_i.split("|") : [];

    const orders = products
      .filter((p) => !!p.es_preventa)
      .map((p, idx) => {
        const picked = arrayPicked.find((row) => row.split(",")[0] == p.id);
        let qtyPicked = 0;
        let isPicked = -1;
        if (picked) {
          const data = picked.split(",");
          qtyPicked = parseInt(data[1]);
          isPicked = data[1] == data[2] ? 1 : -1;
        }
        return {
          id: p.id,
          product_id: p.id,
          productName: p.name,
          productModel: p.model || p.sku,
          productSKU: p.sku,
          productImage: p.imagen,
          productQty: parseInt(p.quantity),
          precio: p.precio || 0,
          precio_lista: p.precio_lista || p.price || 0,
          isPicked,
          qtyPicked,
          state: "loaded",
        };
      });

    let totalPicked = orders.filter((o) => o.isPicked > 0).length;

    this.setState({
      loadingData: false,
      isLoadedTable: true,
      orders,
      order_id,
      customer_id,
      customerName: nombre_cliente,
      branch_name,
      tipo_envio,
      picking_products_i,
      progress_i: orders.length ? Math.ceil((totalPicked / orders.length) * 100) : progress_i,
      username,
      flowcode,
      flowid,
    });

    this.loadPreventaStatus(order_id);
  };

  // ---------------------------------------------------------------------
  // Scan + pick -- mismo patron que externalForm11.js, sobre this.state.orders
  // (ya pre-filtrado a preventa).
  // ---------------------------------------------------------------------
  changeHandlerSKU = async (event) => {
    const value = event.target.value;
    this.setState({ read_sku: value });
    if (value.length < 8) return;

    const item = this.state.orders.find((o) => o.productSKU == value);
    if (!item) {
      this.setState({ read_sku: "" });
      toastOnce("error", "SKU no encontrado entre los items de preventa de este pedido", {
        closeButton: true,
      });
      return;
    }
    const qty = (item.qtyPicked || 0) + 1;
    if (qty <= item.productQty) {
      await this.handlePick(item.id, qty);
      this.setState({ read_sku: "" });
      toastOnce("success", "OK: " + value, { closeButton: true });
    } else {
      this.setState({ read_sku: "" });
      toastOnce("error", "Cantidad del SKU " + value + " superada", { closeButton: true });
    }
  };

  handleBarcodeDetected = (value) => {
    this.changeHandlerSKU({ target: { name: "read_sku", value: value.trim() } });
  };

  handlePick = async (producto, qty) => {
    if (this.state.locked) return;
    this.setState({ isExecuting: true });

    const orders = this.state.orders.map((o) => {
      if (o.id != producto) return o;
      if (qty) {
        return { ...o, qtyPicked: qty, isPicked: qty === o.productQty ? 1 : -1 };
      }
      return {
        ...o,
        qtyPicked: o.isPicked === -1 ? o.productQty : 0,
        isPicked: o.isPicked === -1 ? 1 : -1,
      };
    });

    let product_ids = [];
    let totalPicked = 0;
    for (const o of orders) {
      if (o.qtyPicked > 0) product_ids.push(`${o.product_id},${o.qtyPicked},${o.productQty}`);
      if (o.isPicked > 0) totalPicked++;
    }
    const progress_i = orders.length ? Math.ceil((totalPicked / orders.length) * 100) : 0;
    const picking_products_i = product_ids.join("|");

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "picking_products_i", value: picking_products_i },
          { var: "progress_i", value: progress_i },
        ],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    this.setState({ orders, progress_i, picking_products_i, isExecuting: false });
  };

  // ---------------------------------------------------------------------
  // Ajustar cantidad / eliminar -- mismo endpoint que externalForm11.js.
  // ---------------------------------------------------------------------
  // Tienda (warehouse_code) donde esta cargada la preventa de cada SKU del pedido.
  // El backend la usa para atribuir el cambio de cantidad a la porcion correcta
  // (pickup u origen); con isPickup:false fijo, las unidades extra caian en la
  // porcion origen y salian como stock normal.
  resolveWarehouse = async (sku) => {
    if (!this._whCache) {
      this._whCache = {};
      try {
        const d = await axios({
          method: "post",
          headers: { "Content-Type": "application/json" },
          url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
          data: { order_id: this.state.order_id, apikey: API_CONFIG.casaideasIntToken },
        }).then((r) => r.data);
        ((d && d.items) || []).forEach((i) => {
          this._whCache[i.sku] = String(i.warehouse_code || "").trim();
        });
      } catch (e) {
        this._whCache = null;
      }
    }
    return (this._whCache && this._whCache[sku]) || "";
  };

  commitQtyChange = async (item, newQty) => {
    if (this.state.locked) return;
    this.setState({ isExecuting: true });

    const dataDelOrder = {
      id: item.id,
      orderid: this.state.order_id,
      user: this.state.username,
      quantity: newQty,
      sku: item.productSKU,
      apikey: API_CONFIG.casaideasIntToken,
      isPickup: false,
      warehouse_code: await this.resolveWarehouse(item.productSKU),
      action: "updateOrderProductQty",
    };

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/orders/update",
      data: dataDelOrder,
    }).then((r) => r.data);

    if (!resp.status) {
      toastOnce("error", "ERROR: " + (resp.descResp || "no se pudo actualizar"), { closeButton: true });
      this.setState({ isExecuting: false });
      return;
    }

    const orders =
      newQty === 0
        ? this.state.orders.filter((o) => o.id !== item.id)
        : this.state.orders.map((o) => (o.id === item.id ? { ...o, productQty: newQty } : o));

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "pedido_modificado", value: "SI" },
          { var: "monto_total", value: resp.total },
        ],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    toastOnce("success", "OK: Procesado Correctamente", { closeButton: true });
    this.setState({ orders, isExecuting: false });
  };

  handleIncrement = (item) => this.commitQtyChange(item, item.productQty + 1);
  handleDecrement = (item) =>
    item.productQty <= 1
      ? this.setState({ modalDelete: true, id_producto: item.id })
      : this.commitQtyChange(item, item.productQty - 1);
  handleDeleteClick = (item) => this.setState({ modalDelete: true, id_producto: item.id });
  confirmDelete = () => {
    const item = this.state.orders.find((o) => o.id === this.state.id_producto);
    this.setState({ modalDelete: false });
    if (item) this.commitQtyChange(item, 0);
  };

  // ---------------------------------------------------------------------
  // Agregar producto -- mismo patron que externalForm11.js.
  // ---------------------------------------------------------------------
  changeHandler = (event) => {
    const name = event.target.name || event.target.id;
    this.setState({ [name]: event.target.value });
  };

  searchProduct = async () => {
    this.setState({ isExecuting: true, searchResults: [] });
    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/products/search",
      data: { sku: this.state.SKUcode, apikey: API_CONFIG.casaideasIntToken },
    }).then((r) => r.data);

    if (resp.status && resp.result.length > 0) {
      this.setState({
        searchResults: resp.result.map((r) => ({
          product_id: r.id,
          name: r.name,
          sku: r.sku,
          price: parseFloat(r.price),
        })),
        isExecuting: false,
      });
    } else {
      toastOnce("error", "SKU no encontrado en el catálogo", { closeButton: true });
      this.setState({ isExecuting: false });
    }
  };

  // HU06 Preventa -- valida contra /api/preventa/checkSku antes de dejar
  // agregar, igual que externalForm11.js.
  seleccionarProductoAAgregar = async (producto) => {
    this.setState({
      productoAAgregar: producto,
      checkandoSku: true,
      skuEsPreventa: null,
      skuCheckMessage: "",
    });

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkSku",
      data: { order_id: this.state.order_id, sku: producto.sku, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .catch(() => ({ status: false, message: "No se pudo validar el SKU" }));

    this.setState({
      checkandoSku: false,
      skuEsPreventa: !!resp.es_preventa,
      skuCheckMessage: resp.message || "",
      skuCheckWarehouse: (resp.detalle && resp.detalle.warehouse_code) || "",
    });
  };

  addProduct = async () => {
    if (this.state.locked) return;
    const p = this.state.productoAAgregar;
    if (!p) return;
    if (!this.state.skuEsPreventa) {
      toastOnce("warning", "Este SKU no está confirmado como preventa, no se puede agregar", { closeButton: true });
      return;
    }
    // Mismo SKU ya en el pedido: se suma 1 a la linea existente (antes se creaba
    // una segunda linea con el mismo SKU).
    const existente = this.state.orders.find((o) => o.productSKU === p.sku);
    if (existente) {
      this.setState({
        modalAdd: false,
        productoAAgregar: null,
        skuEsPreventa: null,
        skuCheckMessage: "",
        SKUcode: "",
        searchResults: [],
      });
      await this.commitQtyChange(existente, existente.productQty + 1);
      return;
    }
    this.setState({ isExecuting: true });

    const dataNewOrder = {
      orderid: this.state.order_id,
      productid: p.product_id,
      productname: p.name,
      sku: p.sku,
      price: p.price,
      image: "",
      user: this.state.username,
      quantity: 1,
      apikey: API_CONFIG.casaideasIntToken,
      isPickup: false,
      warehouse_code: this.state.skuCheckWarehouse || "",
      action: "addOrderProduct",
    };

    const resp = await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/orders/update",
      data: dataNewOrder,
    }).then((r) => r.data);

    if (!resp.status) {
      toastOnce("error", "ERROR: no se pudo agregar el producto", { closeButton: true });
      this.setState({ isExecuting: false });
      return;
    }

    const nuevoItem = {
      id: resp.newId || `new_${p.sku}`,
      product_id: p.product_id,
      productName: p.name,
      productModel: p.sku,
      productSKU: p.sku,
      productImage: "",
      productQty: 1,
      precio: 0,
      precio_lista: p.price,
      isPicked: -1,
      qtyPicked: 0,
      state: "loaded",
    };

    await axios({
      url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [{ var: "pedido_modificado", value: "SI" }],
      },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
    });

    toastOnce("success", "Producto agregado", { closeButton: true });
    this.setState({
      orders: [...this.state.orders, nuevoItem],
      modalAdd: false,
      productoAAgregar: null,
      skuEsPreventa: null,
      skuCheckMessage: "",
      SKUcode: "",
      searchResults: [],
      isExecuting: false,
    });
  };

  // ---------------------------------------------------------------------
  // Completar tarea -- sin el chequeo de factura de externalForm11.js: acá
  // nunca se factura, la única condición para avanzar es haber pickeado
  // todo. El optionValue se deja igual ("Pedido listo para entrega") para
  // no tener que duplicar la transición existente 243->238 con otro texto.
  // ---------------------------------------------------------------------
  executeTask = async () => {
    if (this.state.locked) return;

    if (this.state.progress_i < 100) {
      toastOnce("warning", "Debe pickear todos los productos de preventa", { closeButton: true });
      return;
    }

    this.setState({ isExecuting: true });

    await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      url: API_CONFIG.xflowurl + "/engine-users/execute-task",
      data: {
        parentid: this.state.WO_TaskId,
        id: this.state.WO_TaskId,
        optionValue: "Pedido listo para entrega",
        params: {},
      },
      method: "put",
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.status) {
          toastOnce("success", "Procesado con éxito", { closeButton: true });
          setTimeout(() => window.parent.postMessage("TAREA_COMPLETADA", "*"), 1000);
        } else {
          toastOnce("error", "Error ejecutando la tarea: " + data.message, { closeButton: true });
        }
        this.setState({ isExecuting: false });
      });
  };

  render() {
    const { orders, loadingData } = this.state;

    return (
      <>
        <MDBContainer className="xext-page xext-form13">
          <LockOverlay visible={this.state.locked && !loadingData} />
          {loadingData ? (
            <Loader idLoading={loadingData} />
          ) : (
            <>
              <Loader idLoading={this.state.isExecuting} />

              <MDBCard className="mb-3">
                <MDBCardHeader>
                  Picking Individual Preventa (Traspaso) — Pedido #{this.state.order_id}
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBRow>
                    <MDBCol md="6">Cliente: {this.state.customerName}</MDBCol>
                    <MDBCol md="6"><span title="Avance del picking: unidades pickeadas sobre el total del pedido. Queda en 0% hasta que llegue la preventa y se pueda pickear.">
                      Progreso de picking: {this.state.progress_i}% ({this.state.orders.reduce((a, o) => a + (o.qtyPicked || 0), 0)}/
                      {this.state.orders.reduce((a, o) => a + (o.productQty || 0), 0)} unidades)
                    </span></MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>

              <MDBRow className="mb-3">
                <MDBCol md="6">
                  <XInput
                    id="read_sku"
                    name="read_sku"
                    label="Leer SKU (preventa)"
                    placeholder="Ingrese o escanee el código"
                    value={this.state.read_sku}
                    onChange={this.changeHandlerSKU}
                    size="sm"
                  />
                </MDBCol>
                <MDBCol md="3">
                  <BarcodeScanner disabled={this.state.isExecuting} onDetected={this.handleBarcodeDetected} />
                </MDBCol>
                <MDBCol md="3" className="text-right">
                  <XBtn size="sm" color="success" onClick={() => this.setState({ modalAdd: true })}>
                    <MDBIcon icon="cart-plus" /> Agregar producto preventa
                  </XBtn>
                </MDBCol>
              </MDBRow>

              {orders.length === 0 && (
                <MDBAlert color="warning">Este pedido no tiene items en preventa cargados.</MDBAlert>
              )}

              {orders.map((item) => (
                <MDBCard key={item.id} className="mb-2">
                  <MDBCardBody>
                    <MDBRow>
                      <MDBCol md="3" className="xext-item-actions">
                        <div className="xext-qty-stepper">
                          <button
                            type="button"
                            className={`xext-qty-btn ${item.productQty === 1 ? "xext-qty-del" : "xext-qty-minus"}`}
                            aria-label="Disminuir cantidad"
                            onClick={() => this.handleDecrement(item)}
                            disabled={this.state.isExecuting}
                          >
                            {item.productQty === 1 ? <MDBIcon icon="trash-alt" /> : <MDBIcon icon="minus" />}
                          </button>
                          <span className="xext-qty-value">{item.productQty}</span>
                          <button
                            type="button"
                            className="xext-qty-btn xext-qty-plus"
                            aria-label="Aumentar cantidad"
                            onClick={() => this.handleIncrement(item)}
                            disabled={this.state.isExecuting}
                          >
                            <MDBIcon icon="plus" />
                          </button>
                        </div>
                        <XBtn size="sm" color="danger" onClick={() => this.handleDeleteClick(item)}>
                          <MDBIcon icon="trash-alt" /> Eliminar
                        </XBtn>
                      </MDBCol>
                      <MDBCol md="5">
                        <b>{item.productName}</b>
                        <br />
                        SKU: {item.productSKU}
                        {this.state.preventaMap[item.productSKU] === false && (
                          <span className="xext-preventa-pill xext-preventa-pill--pendiente">
                            Preventa: aun no llega
                          </span>
                        )}
                        {this.state.preventaMap[item.productSKU] === true && (
                          <span className="xext-preventa-pill xext-preventa-pill--confirmada">
                            Preventa: lista
                          </span>
                        )}
                      </MDBCol>
                      <MDBCol md="4" className="xext-item-pick">
                        <MDBBadge
                          color={item.isPicked === -1 ? "grey" : "success"}
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handlePick(item.id)}
                        >
                          <MDBIcon icon="check-square" /> Pick ({item.qtyPicked}/{item.productQty})
                        </MDBBadge>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardBody>
                </MDBCard>
              ))}

              <MDBRow className="mt-3">
                <MDBCol className="text-right">
                  <XBtn color="success" onClick={this.executeTask} disabled={this.state.isExecuting}>
                    Pedido listo para entrega
                  </XBtn>
                </MDBCol>
              </MDBRow>
            </>
          )}
        </MDBContainer>

        <MDBModal isOpen={this.state.modalDelete} toggle={() => this.setState({ modalDelete: false })}>
          <MDBModalHeader>Confirmar</MDBModalHeader>
          <MDBModalBody>¿Eliminar este producto de preventa del pedido?</MDBModalBody>
          <MDBModalFooter>
            <XBtn outline color="warning" onClick={() => this.setState({ modalDelete: false })}>
              Cancelar
            </XBtn>
            <XBtn color="danger" onClick={this.confirmDelete}>
              Eliminar
            </XBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.modalAdd} toggle={() => this.setState({ modalAdd: false })}>
          <MDBModalHeader>Agregar producto de preventa</MDBModalHeader>
          <MDBModalBody>
            <MDBRow>
              <MDBCol md="8">
                <XInput id="SKUcode" name="SKUcode" label="SKU" value={this.state.SKUcode} onChange={this.changeHandler} size="sm" />
              </MDBCol>
              <MDBCol md="4">
                <XBtn size="sm" onClick={this.searchProduct}>
                  Buscar
                </XBtn>
              </MDBCol>
            </MDBRow>
            {this.state.searchResults.map((r) => (
              <MDBRow key={r.sku} className="mt-2">
                <MDBCol md="8">
                  {r.name} ({r.sku})
                </MDBCol>
                <MDBCol md="4">
                  <XBtn size="sm" color="success" onClick={() => this.seleccionarProductoAAgregar(r)}>
                    Elegir
                  </XBtn>
                </MDBCol>
              </MDBRow>
            ))}
            {this.state.productoAAgregar && this.state.checkandoSku && (
              <MDBAlert color="info" className="mt-3">
                Validando si <b>{this.state.productoAAgregar.sku}</b> es de preventa…
              </MDBAlert>
            )}
            {this.state.productoAAgregar && !this.state.checkandoSku && this.state.skuEsPreventa === true && (
              <MDBAlert color="success" className="mt-3">
                <MDBIcon icon="check-circle" /> {this.state.skuCheckMessage || "SKU confirmado como preventa"}
              </MDBAlert>
            )}
            {this.state.productoAAgregar && !this.state.checkandoSku && this.state.skuEsPreventa === false && (
              <MDBAlert color="danger" className="mt-3">
                <MDBIcon icon="times-circle" /> {this.state.skuCheckMessage || "Este SKU no es de preventa"}
              </MDBAlert>
            )}
          </MDBModalBody>
          <MDBModalFooter>
            <XBtn outline color="warning" onClick={() => this.setState({ modalAdd: false, productoAAgregar: null })}>
              Cancelar
            </XBtn>
            <XBtn
              color="success"
              onClick={this.addProduct}
              disabled={!this.state.productoAAgregar || this.state.checkandoSku || !this.state.skuEsPreventa}
            >
              Agregar
            </XBtn>
          </MDBModalFooter>
        </MDBModal>

        <ToastContainer hideprogress_Bar={true} newestOnTop={false} />
      </>
    );
  }
}

export default externalForm13;
